import { TValidTestId } from 'types/context-role-element.types';
import { CONTEXT, ELEMENT, ROLE } from '../../context-role-element';

export default {
  [CONTEXT.MFA_PAGE]: {
    [ROLE.FORM]: [ELEMENT.PINCODE],
    [ROLE.BUTTON]: [ELEMENT.RETRY],
  },
} as TValidTestId;
